import React from 'react';
import DashboardTop from './dashboard/DashboardTop';
import DashboardBottom from './dashboard/DashboardBottom';
import BDEPerformanceDashboard from './bde/BDEPerformanceDashboard';
import AnalyticsDashboard from './bde/AnalyticsDashboard';
import PerformanceDashboard from './bde/PerformanceDashboard';
import BDEPerformanceTable from './bde/BDEPerformanceTable';

// Assuming CurrentOpenings is located one level up and in a file named CurrentOpenings

// The following imports are not used in the final component structure 
// but were in your original code, so I'll keep them commented out 
// import MasterComponent from '../../../../../components/Forms'; 
// import { MasterConfigs } from '../../../../../interfaces/entity'; 


/**
 * The main Dashboard Component
 */
const TailwindDashboard: React.FC = () => {

    return (
        <div>
            {/* Existing Dashboard Components */}
            <DashboardTop />
            <DashboardBottom />
            <BDEPerformanceDashboard />
            <AnalyticsDashboard />
            <PerformanceDashboard />
            <BDEPerformanceTable />
         

            {/* Added your CurrentOpenings Component here */}
            {/* <CurrentOpenings /> */}
        </div>
    );
};

export default TailwindDashboard;